export type PreviewKind = "pdf" | "sheet" | "image" | "none"

const SHEET_EXTENSIONS = new Set(["xlsx", "xlsm", "xls", "csv"])
const IMAGE_EXTENSIONS = new Set(["png", "jpg", "jpeg"])

const SHEET_MIMETYPES = new Set([
  "text/csv",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-excel.sheet.macroenabled.12",
])
// Explicit set, not a generic `image/*` prefix match: an SVG, HEIC, TIFF etc.
// carries an `image/` mimetype too but has no renderer here and should fall
// through to 'none' rather than being misrouted into the image branch.
const IMAGE_MIMETYPES = new Set(["image/png", "image/jpeg"])
const PDF_MIMETYPE = "application/pdf"

/** Bare lowercase extension without the leading dot, or '' when the file
 * name has none. */
function fileExtension(fileName: string): string {
  const dot = fileName.lastIndexOf(".")
  if (dot < 0 || dot === fileName.length - 1) return ""
  return fileName.slice(dot + 1).toLowerCase()
}

/** Which preview renderer, if any, applies to a data room file. Extension is
 * checked first (matches how these files are actually named); the mimetype
 * is only a fallback for files whose extension doesn't say. */
export function previewKind(fileName: string, mimetype: string): PreviewKind {
  const ext = fileExtension(fileName)
  const mime = mimetype.toLowerCase()

  if (ext === "pdf" || mime === PDF_MIMETYPE) return "pdf"
  if (SHEET_EXTENSIONS.has(ext) || SHEET_MIMETYPES.has(mime)) return "sheet"
  if (IMAGE_EXTENSIONS.has(ext) || IMAGE_MIMETYPES.has(mime)) return "image"
  return "none"
}
